class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    const id = this.dataset.productId;
    if (!id) return;
    this.dataset.loaded = 'true';
    const exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
    fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}recommendations/products.json?product_id=${id}&intent=related&limit=6`)
      .then((r) => r.json())
      .then((data) => {
        const items = (data.products || []).filter((p) => !exclude.includes(String(p.id))).slice(0, 4);
        if (!items.length) return;
        const list = this.querySelector('[data-reco-list]');
        if (!list) return;
        list.innerHTML = items
          .map((p) => {
            const img = p.featured_image
              ? `<img src="${p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="" loading="lazy" width="64" height="64">`
              : '<span class="cart-reco__ph"></span>';
            const price = p.price_min !== undefined ? p.price_min : p.price;
            const money = (price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD' });
            return `<li class="cart-reco__item"><a class="cart-reco__link" href="${p.url}"><span class="cart-reco__media">${img}</span><span class="cart-reco__text"><span class="cart-reco__title">${p.title}</span><span class="cart-reco__price">${money}</span></span></a></li>`;
          })
          .join('');
        this.hidden = false;
      })
      .catch(() => {});
  }
}
if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
